import { Injectable } from '@angular/core';
import { injectMutation } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';
import { SearchDossierResponse } from '../models/externalLinks/searchDossiers.model';
import { BaseApiService } from './base.api.service';

@Injectable({ providedIn: 'root' })
export class ExternalLinksService extends BaseApiService {
  // private myMeetings: QueryKey = ['myMeetings'];

  askVerificationCode = injectMutation(
    () => ({
      retry: false,
      enabled: false,
      mutationFn: (args: {
        methode: string;
        identifiant: string;
        logiciel: string;
      }) =>
        lastValueFrom(
          this.httpClient.post<any>(
            `${this.baseUrl}/api/core/externalLinks/checkPersonnalDetails`,
            {
              logiciel: args.logiciel,
              mode: args.methode,
              identifiant: args.identifiant,
            },
            {
              withCredentials: true,
            }
          )
        ),
    })
    //  onSuccess: () => this.queryClient.invalidateQueries({ queryKey: this.myMeetings }),
  );

  validateVerificationCode = injectMutation(
    () => ({
      retry: false,
      enabled: false,
      mutationFn: (args: {
        methode: string;
        identifiant: string;
        logiciel: string;
        code: string;
      }) =>
        lastValueFrom(
          this.httpClient.post<SearchDossierResponse>(
            `${this.baseUrl}/api/core/externalLinks/validatePersonnalDetails`,
            {
              logiciel: args.logiciel,
              mode: args.methode,
              identifiant: args.identifiant,
              code: args.code,
            },
            {
              withCredentials: true,
            }
          )
        ),
    })
    //  onSuccess: () => this.queryClient.invalidateQueries({ queryKey: this.myMeetings }),
  );

  validateExternalLink = injectMutation(() => ({
    retry: false,
    enabled: false,
    mutationFn: (args: {
      methode: string;
      identifiant: string;
      logiciel: string;
      code: string;
      verificationTokenProof: string;
      identifiantDossier: string;
    }) =>
      lastValueFrom(
        this.httpClient.post<SearchDossierResponse>(
          `${this.baseUrl}/api/core/externalLinks/validateExternalLink`,
          {
            logiciel: args.logiciel,
            mode: args.methode,
            identifiant: args.identifiant,
            code: args.code,
            verificationTokenProof: args.verificationTokenProof,
            identifiantDossier: args.identifiantDossier,
          },
          {
            withCredentials: true,
          }
        )
      ),
  }));
}
